/* eslint-disable */
if (window._env_.HEAP_ENABLED) {
  (window.heap = window.heap || []),
    (heap.load = function (e, t) {
      (window.heap.appid = e), (window.heap.config = t = t || {});
      const r = t.forceSSL || 'https:' === document.location.protocol,
        a = document.createElement('script'),
        scriptSourcePrefix = window._env_.CDN_ENABLED
          ? `${window._env_.CDN_HOSTNAME}/js/heap`
          : 'cdn.heapanalytics.com/js';
      (a.type = 'text/javascript'),
        (a.async = !0),
        (a.src = `${r ? 'https:' : 'http:'}//${scriptSourcePrefix}/heap-${e}.js`);
      document.head.appendChild(a);
      for (
        let o = function (e) {
            return function () {
              if (heap) {
                heap.push([e].concat(Array.prototype.slice.call(arguments, 0)));
              } else {
                console.error('HEAP - There has been an error pushing data to Heap.');
              }
            };
          },
          p = [
            'clearEventProperties',
            'addEventProperties',
            'addUserProperties',
            'identify',
            'resetIdentity',
            'removeEventProperty',
            'setEventProperties',
            'track',
            'unsetEventProperty',
          ],
          c = 0;
        c < p.length;
        c++
      ) {
        heap[p[c]] = o(p[c]);
      }
    });
  heap.load(window._env_.HEAP_TRACKING_ID);
}
